import { FC, useMemo } from "react";
import { Link } from "react-router-dom";
import { TestIcon } from "routes/analysis/helpers/analysisHelpers";
import PercentageBar from "components/common/percentageBar";
import UserStatistics from "components/common/userStatistics";
import { UserListData, RuleFunction, RuleTest } from "routes/analysis/types/analysis";
import { parseStats } from "../helpers/helpers";

const TransactionInfo: FC<{ userList: UserListData, ruleFunction?: RuleFunction }> = ({ userList, ruleFunction }) => {
  const stats = useMemo(() => parseStats(userList), [userList]);
  return (
    <>
      <h1>Transaction</h1>
      <div className="ap-list-header ap-business-process-header flex items-center p-5 gap-4">
        <div className="basis-60">Test</div>
        <div className="basis-60">Function</div>
        <div className="basis-60">Tests</div>
        <div className="basis-60"></div>
        <div className="grow">Distinct user matches</div>
      </div>
      <div className="list-row-1 flex items-center p-4 gap-4 mb-4">
        <div className="basis-60">
          <b>{userList.transaction?.identifier}</b>
          <p>{userList.transaction?.description}</p>
        </div>
        <div className="basis-60">
          <b>{ruleFunction?.identifier}</b>
          <p>{ruleFunction?.description}</p>
        </div>
        <div className="basis-60">
          {userList.tests?.map((test: RuleTest) => (
            <Link to={`/analysis/${userList.analysisId}/users/test/${test.testId}`} key={`${userList.transactionId}:${test.testId}`}>
              <p key={`${userList.transactionId}-${test}`}><b>{test.identifier}</b> <TestIcon type={test.type} /></p>
            </Link>
          ))}
        </div>
        <div className="basis-60">
          <PercentageBar
            percentage={
              Math.round((userList.pagination.items / userList.pagination.totalItems) * 100)
            }
            dark
          />
        </div>
        <div className="grow">
          <UserStatistics stats={stats} />
        </div>
      </div>
    </>
  );
};

export default TransactionInfo;
